import styled from '@emotion/styled';
import { Space } from 'antd';

export const SadaCaseStatusButtons = styled(Space)``;
